export var CLIENT_VERSION = "4.19.0";